var lib_core = require("lib-core");
var ContentServerMetaData = require("../contentServerMetaData.js");
var Properties = require("cio-config").MetaProperties;

var PackageMetaData = function () {
    ContentServerMetaData.call(this);

    for(var key in Properties["package"]){
        if(Properties["package"].hasOwnProperty(key))
            this[key] = this.value(key, true);
    }
};

lib_core.inherit(PackageMetaData, ContentServerMetaData);
lib_core.JsonParser.registerClass(PackageMetaData, "PackageMetaData");
module.exports = PackageMetaData;

PackageMetaData.prototype.assetType = function () {
	return "package";
};

PackageMetaData.prototype.assetPath = function () {
	return "packages/";
};
